import { useMemo } from "react";
import { useSelector } from "react-redux";

const useUserCompany = () => {
  const currentCompanyId = useSelector((state) => state.user.currentCompany);
  const company = useSelector((state) => state.user.company);

  return useMemo(
    () =>
      currentCompanyId !== null
        ? company?.find((com) => com.comId === parseInt(currentCompanyId))
        : null,
    [company, currentCompanyId]
  );
};

export default useUserCompany;
